//@ts-check

class ClearanceRequestService {
	constructor($http, $window, $timeout, $rootScope, InternalLinksService, LocalStorageService) {
		this.$http = $http;
		this.$window = $window;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.LocalStorageService = LocalStorageService;
		this.InternalLinksService = InternalLinksService;

		this.init();
	}

	init() {
		this.clearanceRequest = {};
	}

	async loadClearanceRequestByCorrelationId(correlationId) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			if (!correlationId) {
				throw new Error('Correlation Id must be supplied.');
			}

			let url = await this.InternalLinksService.getLink('GetClearance');

			if (!url) {
				await this.InternalLinksService.getLinks('api/clearance/links', false);
				url = await this.InternalLinksService.getLink('GetClearance');
			}
			url = `${url}?correlationId=${correlationId}`;

			const results = await this.$http.get(url);
			const { data } = results;
			this.clearanceRequest = this._map(data);
			const { IsSubmitted } = data || {
				IsSubmitted: false
			};

			this.isSubmitted = IsSubmitted;
			this.$timeout(() => promiseHandler.resolve(data));
		} catch (err) {
			const msg = `Error while fetching clearance data`;
			console.error(msg, err);
			this.clearanceRequest = {};
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async SaveInitialClearanceRequest(initialRequest) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});
			if (!initialRequest) {
				throw new Error('no initial request data');
			}
			let url = await this.InternalLinksService.getLink('SaveInitialClearanceRequest');
			if (!url) {
				await this.InternalLinksService.getLinks('api/clearance/links', false);
				url = await this.InternalLinksService.getLink('SaveInitialClearanceRequest');
			}

			const results = await this.$http.post(url,initialRequest);
			const { data } = results;
			this.$timeout(() => promiseHandler.resolve(data));
		} catch (error) {
			const msg = `Error while saving Clearance Request.`;
			console.error(msg, error);
			this.$timeout(() => promiseHandler.reject(error));
		}

		return promise;
	}

	async SearchAvailableAttorneyNames(searchTerm) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});
			
			if (!searchTerm) {
				throw new Error('no initial request data');
			}
			let url = await this.InternalLinksService.getLink('SearchAvailableAttorneyNames');
			if (!url) {
				await this.InternalLinksService.getLinks('api/clearance/links', false);
				url = await this.InternalLinksService.getLink('SearchAvailableAttorneyNames');
			}

			const results = await this.$http.post(url,{SearchTerm: searchTerm});
			const { data } = results;
			this.$timeout(() => promiseHandler.resolve(data.Data));
		} catch (error) {
			const msg = `Error while searching available attorneyNames.`;
			console.error(msg, error);
			this.$timeout(() => promiseHandler.reject(error));
		}

		return promise;
	}

	_map(data) {
		if (!data) return data;

		if (!data.IsSubmitted) {
			data = this._formatAndMapDate(data);
		} else {
			data.ValidDate = data.ValidDate.substr(0, 10);
		}

		data = this._mapSellerInfo(data);
		return data;
	}
	_formatAndMapDate(original) {
		const mapped = original;
		const { ValidDate } = mapped;

		let momentDate,
			// @ts-ignore
			initDate = new moment(new Date()),
			// @ts-ignore
			momentInitDate = moment(ValidDate);

		if (ValidDate && momentInitDate.year() !== 1900) {
			// @ts-ignore
			momentDate = moment(ValidDate);
			if (initDate.isBefore(momentDate)) {
				initDate = momentDate;
			}
		} else {
			// @ts-ignore
			const currentMomentDate = moment(initDate);
			const currentDay = currentMomentDate.date();

			if (currentDay < 15) {
				initDate.add(2, 'M');
			} else {
				initDate.add(3, 'M');
			}

			// @ts-ignore
			initDate = moment(`${initDate.format('YYYY/MM/')}${initDate.daysInMonth()}`, 'YYYY/MM/DD');
		}

		mapped.ValidDate = initDate.format('YYYY/MM/DD');

		return mapped;
	}

	_mapSellerInfo(data) {
		const oldSellerEmails = data.SellerEmail;
		data.SellerEmail = '';
		data.SellerEmail = this._mapSenderEmails(oldSellerEmails);

		return data;
	}

	_mapSenderEmails(sellerEmail) {
		const sellerEmails = sellerEmail.indexOf(';') ? sellerEmail.split(';') : [ sellerEmail ];

		let mappedSellerEmails = '';
		if (sellerEmails.length > 1) {
			for (const email of sellerEmails) {
				mappedSellerEmails += `${email}\n`;
			}
			mappedSellerEmails = mappedSellerEmails.substr(0, mappedSellerEmails.lastIndexOf('\n'));
		} else {
			mappedSellerEmails = sellerEmails[0];
		}

		return mappedSellerEmails;
	}
}

export default /* @ngInject */ ($http, $window, $timeout, $rootScope, InternalLinksService, LocalStorageService) =>
	new ClearanceRequestService($http, $window, $timeout, $rootScope, InternalLinksService, LocalStorageService);
